import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";
import { CustomSegmentationFields } from "@appetize/iw-common/interfaces/featureFlags/featureFlags";

const http: AxiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

const getFeatureFlags = (
  customSegmentationFields: CustomSegmentationFields,
  featureFlags: string = "",
  showSpinner = true,
  applyToken = true
): Promise<AxiosResponse> => {
  return http.post(`/featureflags`, customSegmentationFields, {
    params: featureFlags ? { flagIds: featureFlags } : {},
    showSpinner,
    applyToken
  } as AxiosRequestConfig);
};

export default {
  getFeatureFlags
};
